import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'SpinnerBar',
  props: {
    animationOn: { type: Boolean },
    size: { default: "sm" }
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["spinner-bar", `spinner-bar-${props.size}`])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["runner", { 'animation-stopped': !props.animationOn }])
    }, null, 2)
  ], 2))
}
}

})